import * as React from 'react';
import { cn } from '@/lib/utils';

export interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {}

const Input = React.forwardRef<HTMLInputElement, InputProps>(
  ({ className, type, ...props }, ref) => {
    return (
      <input
        type={type}
        className={cn(
          'flex h-10 w-full rounded-lg border border-[var(--border-color)] bg-[var(--bg-primary)] px-3 py-2 text-sm',
          'text-[var(--text-primary)] placeholder:text-[var(--text-secondary)]',
          'focus:outline-none focus:border-dyndev-green focus:ring-1 focus:ring-dyndev-green',
          'disabled:cursor-not-allowed disabled:opacity-50',
          'transition-all duration-200',
          'file:border-0 file:bg-transparent file:text-sm file:font-medium',
          // Date input: position the calendar icon at the right edge, vertically centred
          type === 'date' && [
            'pr-9',
            '[&::-webkit-calendar-picker-indicator]:absolute',
            '[&::-webkit-calendar-picker-indicator]:right-2',
            '[&::-webkit-calendar-picker-indicator]:top-1/2',
            '[&::-webkit-calendar-picker-indicator]:-translate-y-1/2',
            '[&::-webkit-calendar-picker-indicator]:opacity-50',
            '[&::-webkit-calendar-picker-indicator]:transition-opacity',
            '[&::-webkit-calendar-picker-indicator]:cursor-pointer',
            'hover:[&::-webkit-calendar-picker-indicator]:opacity-100',
          ],
          className
        )}
        ref={ref}
        {...props}
      />
    );
  }
);
Input.displayName = 'Input';

export { Input };
